module.exports = __webpack_public_path__ + "static/media/avatar.6a8ced16.svg";